import axios from "axios";
import Fuse from "fuse.js";
import { auth } from "./firebase";

export const getUser=(dispatch)=>{
  auth.onAuthStateChanged((user) => {
    if (user) {
      dispatch({
        type: "SET_USER",
        user: user,
      });
    } else {
      dispatch({
        type: "SET_USER",
        user: null,
      });
    }
  });
}
export const getProducts = async (dispatch,loadingBar) => {
  try {
    const { data } = await axios.get("/products.json");
    dispatch({
      type: "SET_PRODUCTS",
      products: data,
    });
    const fuse = new Fuse(data, { keys: ["name", "category"] });
    dispatch({
      type: "SET_FUSE",
      fuse: fuse,
    });
    loadingBar.current.complete();
  } catch (error) {
    console.log(error);
    loadingBar.current.complete();
  }
};

export const shuffleArray = (array) => {
  let shuffled = [...array];
  for (let i = shuffled.length - 1; i > 0; i--) {
    let j = Math.floor(Math.random() * (i + 1));
    [shuffled[i], shuffled[j]] = [shuffled[j], shuffled[i]];
  }
  return shuffled;
};
